import React from 'react';
import "../less/quickCash.less"
import hero_img from '../img/quick_cash/hero_img.png';
import Advantages from '../../../auxiliary-components/shared/AdvantagesBlock';
import advantages_img_1 from '../img/quick_cash/advantages_img_1.png';
import advantages_img_2 from '../img/quick_cash/advantages_img_2.png';
import advantages_img_3 from '../img/quick_cash/advantages_img_3.png';
import AdditionalProduct from '../../../auxiliary-components/shared/AdditionalProductBlock';
import QuestionsAdminNew from '../../../auxiliary-components/shared/QuestionsAdminNew';
import FilesForDownloadNew from "../../../auxiliary-components/shared/FilesForDownloadNew";
import TextAboveFooterNew from "../../../auxiliary-components/shared/TextAboveFooterNew";
import FAQStorybook from '@abank/abank-faq';
import CalculatorNew from '../../../auxiliary-components/CalculatorNew';
import Tabs from '../../../auxiliary-components/shared/Tabs';
import Tariffs from '../../../auxiliary-components/shared/TariffsBlock';
import HowToBlockNew from '../../../auxiliary-components/shared/HowToBlockNew';
import how_to_block_img_1 from '../img/quick_cash/how_to_block_img_1.png';
import how_to_block_img_2 from '../img/quick_cash/how_to_block_img_2.png';
import how_to_block_img_3 from '../img/quick_cash/how_to_block_img_3.png';
import how_to_block_zero_img_1 from '../img/quick_cash/zero/how_to_block_img_1.png';
import how_to_block_zero_img_2 from '../img/quick_cash/zero/how_to_block_img_2.png';
import how_to_block_zero_img_3 from '../img/quick_cash/zero/how_to_block_img_3.png';
import how_to_block_salaryplus_img_1 from '../img/quick_cash/salaryplus/how_to_block_img_1.png';
import how_to_block_salaryplus_img_2 from '../img/quick_cash/salaryplus/how_to_block_img_2.png';
import how_to_block_salaryplus_img_3 from '../img/quick_cash/salaryplus/how_to_block_img_3.png';
import how_to_block_addcash_img_1 from '../img/quick_cash/addcash/how_to_block_img_1.png';
import how_to_block_addcash_img_2 from '../img/quick_cash/addcash/how_to_block_img_2.png';
import how_to_block_addcash_img_3 from '../img/quick_cash/addcash/how_to_block_img_3.png';
import Hero from '../../../auxiliary-components/shared/HeroBlock';
import additional_product_img_1 from '../img/quick_cash/additional_product_img_1.png';
import additional_product_img_2 from '../img/quick_cash/additional_product_img_2.png';
import QuickCashOrder from "../../QuickCashOrder";
import TextBlock from '../../../auxiliary-components/shared/TextBlock';
import tariffsDataZero from '../enums/quick_cash/tariffs_data_zero.json';
import tariffsDataSalaryPlus from '../enums/quick_cash/tariffs_data_salary_plus.json';
import tariffsDataAddCash from '../enums/quick_cash/tariffs_data_add_cash.json';
import howToBlockItemsGeneralData from '../enums/quick_cash/how_to_block_items_general.json';
import howToBlockItemsZeroData from '../enums/quick_cash/how_to_block_items_zero.json';
import howToBlockItemsSalaryPlusData from '../enums/quick_cash/how_to_block_items_salary_plus.json';
import howToBlockAddCashData from '../enums/quick_cash/how_to_block_items_add_cash.json';
import advantagesItems1Data from '../enums/quick_cash/advantages_items_01.json';
import advantagesItems2 from '../enums/quick_cash/advantages_items_02.json';
import additionalCardsData from '../enums/quick_cash/additional_cards.json';
import { Preloader } from 'MWComponents';
import { canUseDOM } from '../../../helpers/canUseDOM';
import { filterByEnvironment } from '../../../helpers/utils/environmentFilter';

export default function template() {
    const page = 'quick-cash-new';
    const model = this.getModel();
    const addcashCalcFile = '/static/quickCash/calc_exclusive.xlsx';
    const zeroCalcFile = '/static/quickCash/calc_zero.xlsx';

    const imagesMap = {
      how_to_block_img_1,
      how_to_block_img_2,
      how_to_block_img_3,
      how_to_block_zero_img_1,
      how_to_block_zero_img_2,
      how_to_block_zero_img_3,
      how_to_block_salaryplus_img_1,
      how_to_block_salaryplus_img_2,
      how_to_block_salaryplus_img_3,
      how_to_block_addcash_img_1,
      how_to_block_addcash_img_2,
      how_to_block_addcash_img_3,
      advantages_img_1,
      advantages_img_2,
      advantages_img_3,
      additional_product_img_1,
      additional_product_img_2
    };

    const howToBlockItemsGeneral = howToBlockItemsGeneralData.map(item => ({
      ...item,
      img: imagesMap[item.img]
    }));

    const howToBlockItemsZero = howToBlockItemsZeroData.map(item => ({
      ...item,
      img: imagesMap[item.img]
    }));

    const howToBlockItemsSalaryPlus = howToBlockItemsSalaryPlusData.map(item => ({
      ...item,
      img: imagesMap[item.img]
    }));

    const howToBlockAddCash = howToBlockAddCashData.map(item => ({
      ...item,
      img: imagesMap[item.img]
    }));

    const advantagesItems1 = advantagesItems1Data.map(item => ({
      ...item,
      img: imagesMap[item.img]
    }));

    const additionalCards = additionalCardsData.map(item => ({
      ...item,
      img: imagesMap[item.img]
    }));

    const tabsInfo = [{tab: 'calculator', title: 'QUICK_CASH_NEW_TABS_INFO_TITLE_01'},
          {tab: 'get-services', title: 'QUICK_CASH_NEW_TABS_INFO_TITLE_02'},
          {tab: 'payments', title: 'QUICK_CASH_NEW_TABS_INFO_TITLE_03'}];

    const tabsSpecialOffers = [{tab: 'zero', title: 'QUICK_CASH_NEW_TABS_SPECIAL_OFFERS_TITLE_01'},
          {tab: 'salaryplus', title: 'QUICK_CASH_NEW_TABS_SPECIAL_OFFERS_TITLE_02'},
          {tab: 'addcash', title: 'QUICK_CASH_NEW_TABS_SPECIAL_OFFERS_TITLE_03'}];

    const tabsShortQuestions = [{tab: 'general-questions-short', title: 'QUICK_CASH_NEW_TABS_QUESTIONS_TITLE_01'},
        {tab: 'zero-questions-short', title: 'QUICK_CASH_NEW_TABS_QUESTIONS_TITLE_02'},
        {tab: 'salaryplus-questions-short', title: 'QUICK_CASH_NEW_TABS_QUESTIONS_TITLE_03'},
        {tab: 'addcash-questions-short', title: 'QUICK_CASH_NEW_TABS_QUESTIONS_TITLE_04'}];

    const tabsAllQuestions = [{tab: 'general-questions-full', title: 'QUICK_CASH_NEW_TABS_QUESTIONS_TITLE_01'},
        {tab: 'zero-questions-full', title: 'QUICK_CASH_NEW_TABS_QUESTIONS_TITLE_02'},
        {tab: 'salaryplus-questions-full', title: 'QUICK_CASH_NEW_TABS_QUESTIONS_TITLE_03'},
        {tab: 'addcash-questions-full', title: 'QUICK_CASH_NEW_TABS_QUESTIONS_TITLE_04'}];

    const hero_data = {
      title: 'QUICK_CASH_NEW_HERO_TITLE',
      text: 'QUICK_CASH_NEW_HERO_TEXT',
      link: {
        text: "QUICK_CASH_NEW_HERO_BTN",
        onClick: () => this.toggleModal(false),
      },
      cards: [
        {
          title: 'QUICK_CASH_NEW_CARDS_HERO_TITLE_01',
          text: 'QUICK_CASH_NEW_CARDS_HERO_TEXT_01',
        },
        {
          title: 'QUICK_CASH_NEW_CARDS_HERO_TITLE_02',
          text: 'QUICK_CASH_NEW_CARDS_HERO_TEXT_02',
        },
        {
          title: 'QUICK_CASH_NEW_CARDS_HERO_TITLE_03',
          text: 'QUICK_CASH_NEW_CARDS_HERO_TEXT_03',
        }
      ]
    };

    const questionsWidgets = [
      this.widgetsHelper.getWidget.call(this, 'questions'),
      this.widgetsHelper.getWidget_2.call(this, 'questions'),
      this.widgetsHelper.getWidget_3.call(this, 'questions'),
      this.widgetsHelper.getWidgetFrom.call(this, 'widgets_4', 'questions')
    ];
    
    return (
        <div className="quick-cash-new">
          <Hero
            data={hero_data}
            img={hero_img}
            page={page}
          />
          <div className={`content${this.state.faqTab ? ' hidden' : ''}`}>
            <Advantages
              items={advantagesItems1}
              title={'QUICK_CASH_NEW_ADVANTAGES_TITLE'}
            />
            <Tabs tabs={tabsInfo} toggle={this.toggleInfoTab} tab={this.state.tabInfo} page={page}>
              {model.creditSum ? (
                <CalculatorNew model={model} type={"quick_cash"} toggleModal={this.toggleModal} isBtn={true} {...this.props} page={page} tab={this.state.tabInfo}/>
              ) : (canUseDOM ? <Preloader /> : null)}
              <HowToBlockNew
                items={howToBlockItemsGeneral}
                title={'QUICK_CASH_NEW_HOW_TO_GENERAL_TITLE'}
              />
              <Advantages
                items={advantagesItems2}
              />
            </Tabs>
            <Tabs tabs={tabsSpecialOffers} toggle={this.toggleSpecialOffersTab} tab={this.state.tabSpecialOffer} id='special-offers-new-tabs' title={'QUICK_CASH_NEW_TABS_SPECIAL_OFFERS_TITLE'} page={page}>
              <div>
                <Tariffs
                  items={tariffsDataZero}
                  page={page}
                />
                <HowToBlockNew
                  title={'QUICK_CASH_NEW_HOW_TO_ZERO_TITLE'}
                  items={howToBlockItemsZero}
                  page={page}
                  btnLink={zeroCalcFile}
                  btnText={'QUICK_CASH_NEW_HOW_TO_ZERO_BTN'}
                  btnId={'zero'}
                  titleTag={'h3'}
                />
              </div>
              <div>
                <Tariffs
                  items={tariffsDataSalaryPlus}
                  page={page}
                />
                <TextBlock text={"QUICK_CASH_NEW_SALARY_PLUS_TEXT"}/>
                <HowToBlockNew
                  title={'QUICK_CASH_NEW_HOW_TO_SALARY_PLUS_TITLE'}
                  items={howToBlockItemsSalaryPlus}
                  page={page}
                  onBtnClick={this.scrollToCalculatorForce}
                  btnText={'QUICK_CASH_NEW_HOW_TO_SALARY_PLUS_BTN'}
                  btnId={'salaryplus'}
                  titleTag={'h3'}
                />
              </div>
              <div>
                <Tariffs
                  items={tariffsDataAddCash}
                  page={page}
                />
                <TextBlock text={"QUICK_CASH_NEW_ADD_CASH_TEXT"}/>
                <HowToBlockNew
                  title={'QUICK_CASH_NEW_HOW_TO_ADD_CASH_TITLE'}
                  items={howToBlockAddCash}
                  page={page}
                  btnLink={addcashCalcFile}
                  btnText={'QUICK_CASH_NEW_HOW_TO_ADD_CASH_BTN'}
                  btnId={'addcash'}
                />
              </div>
            </Tabs>
            <AdditionalProduct
              items={additionalCards}
              title={'QUICK_CASH_NEW_ADDITIONAL_PRODUCT_TITLE'}
              page={page}
            />
            <Tabs tabs={tabsShortQuestions} toggle={this.toggleShortQuestionTab} tab={this.state.tabShortQuestions} title={'QUICK_CASH_NEW_TABS_SHORT_QUESTIONS_TITLE'} page={page}>
              {questionsWidgets.map((widget, i) => (
                <QuestionsAdminNew
                  key={i}
                  page={page}
                  widget={widget}
                  toggleFaqTab={this.toggleFaqTab}
                />
              ))}
            </Tabs>
            <FilesForDownloadNew
              widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
            />
            <TextAboveFooterNew
              widget={this.widgetsHelper.getWidget.call(this, 'text_above_footer')}
            />
          </div>
          <div className={`content${!this.state.faqTab ? ' hidden' : ''}`}>
            <Tabs tabs={tabsAllQuestions} toggle={this.toggleAllQuestionsTab} tab={this.state.tabAllQuestions}>
              {questionsWidgets.map((widget, i) => (
                <FAQStorybook
                  key={i}
                  widget={widget}
                  title={this.l10n('QUICK_CASH_NEW_FAQ_STORYBOOK_TITLE')}
                  btnText={this.l10n('QUICK_CASH_NEW_FAQ_STORYBOOK_BTN_TEXT')}
                  onBtnClick={this.toggleFaqTab}
                  filterByEnvironment={filterByEnvironment}
                />
              ))}
            </Tabs>
          </div>
          {this.state.showModal &&
            <QuickCashOrder 
              closeModal={this.toggleModal} 
              utmParams={this.utmParams} 
              loanTerm={this.state.loanTerm} 
              loanSum={this.state.loanSum}
            />
          }
        </div>
    );
}
